import { ChatMessageTextInterface } from "../interfaces";
// import { useAppDispatch } from "../store/hooks";

const ChatMessageStatus: React.FC<ChatMessageTextInterface> = ({
  // hideAvatar,
  // values,
  // triggerNextStep,
  // handleInputSubmit,
  step,
  // setDataValues,
  // currentStep,
  // scrollToBottom,
  // disableScrollToBottom,
  // disableTypingAnimation = false,
}) => {
  // const dispatch = useAppDispatch();
  const {
    // input,
    // end,
    // delay,
    // message,
    // options,
    // trigger,
    theme,
    status,
    assignedAgent,
  } = step!;

  return (
    <div className="conversation-status-wrapper">
      <h6
        className="conversation-status"
        style={{
          color: theme?.customization?.primaryColor,
        }}
      >
        {status}
      </h6>
      {status?.includes("has joined the conversation") && (
        <h6
          className="conversation-status"
          style={{
            color: theme?.customization?.primaryColor,
          }}
        >
          <img
            className="conversation-status-avatar"
            width="30"
            height="30"
            src={assignedAgent?.image}
            alt={assignedAgent?.name}
          />
          <b>{assignedAgent?.name}</b>| Live Chat Expert for{" "}
          {theme?.customization?.companyName}
        </h6>
      )}
    </div>
  );
};

export default ChatMessageStatus;
